import router, { asyncRoutes } from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { filterMenuByPath } from '@/utils/menu-filter'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/register', '/forgot'] // no redirect whitelist
const NO_MENU_NOTICE_KEY = 'login-no-menu-notice'

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // 空权限账号的 roles 可能是空数组，不能再用 roles.length 判断是否已完成初始化
      const userInfoLoaded = store.getters.userInfoLoaded
      if (userInfoLoaded) {
        next()
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const { roles, menus } = await store.dispatch('user/getInfo')
          // 根据接口返回的 menus 过滤本地路由树，使用接口的 menuName
          const allRoutes = asyncRoutes || []
          const normalizedMenus = Array.isArray(menus) ? [...menus] : []
          const h7Declaration = normalizedMenus.find(item => item.path === '/h7/declaration')
          if (h7Declaration) {
            normalizedMenus.push(
              {
                path: '/h7/declaration-detail',
                menuType: 'C'
              }
            )
          }
          const accountUser = normalizedMenus.find(item => item.path === '/account/role')
          if (accountUser) {
            normalizedMenus.push(
              {
                path: '/account/role-add',
                menuType: 'C'
              }
            )
          }
          let filteredRoutes = filterMenuByPath(allRoutes, normalizedMenus)
          // 检查是否为 admin 角色，如果是则额外添加菜单管理的路由
          const isAdmin = Array.isArray(roles) && roles.some(role => role === 'admin' || (role && role.roleKey === 'admin'))
          if (isAdmin) {
            // 为 admin 角色添加菜单管理路由（如果接口没有返回的话）
            const menuRouteExists = filteredRoutes.some(route => route.path === '/menu')
            if (!menuRouteExists) {
              // 从原始路由中查找菜单管理路由并添加
              const menuRoute = allRoutes.find(route => route.path === '/menu')
              if (menuRoute) {
                filteredRoutes = [...filteredRoutes, menuRoute]
              }
            }
          }

          const hasMenuAccess = filteredRoutes.some(route => route.path !== '*')
          if (!hasMenuAccess) {
            sessionStorage.setItem(NO_MENU_NOTICE_KEY, '1')
            await store.dispatch('user/resetToken')
            // this.$message.success('888')
            next({ path: '/login', replace: true })
            NProgress.done()
            return
          }

          // 始终添加 404 路由到所有用户的菜单中（用于捕获未匹配的路由）
          const has404Route = filteredRoutes.some(route => route.path === '*')
          if (!has404Route) {
            // 从原始路由中查找 404 路由并添加
            const notFoundRoute = allRoutes.find(route => route.path === '*')
            if (notFoundRoute) {
              filteredRoutes.push(notFoundRoute)
            }
          }

          // 设置过滤后的路由到 store
          await store.dispatch('permission/setFilteredRoutes', filteredRoutes)

          // dynamically add accessible routes
          router.addRoutes(filteredRoutes)

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      // 避免redirect参数重复累积
      const redirect = (to.path === '/register' || to.path === '/forgot') ? '' : `?redirect=${to.path}`
      next(`/login${redirect}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
